export default __webpack_public_path__ + "static/promo-bg-8cc25aa905c17376f02fc013d6e89afd.png";